import LegalLinksDrawer from './LegalLinksDrawer/LegalLinksDrawer';
import NittyGritty from './NittyGritty/NittyGritty';
import { ContextProvider, useLegalContext } from './store/legal-context';
export var Legal = function (_a) {
    var children = _a.children;
    return { children: children };
};
Legal.ContextProvider = ContextProvider;
Legal.useLegalContext = useLegalContext;
Legal.NittyGritty = NittyGritty;
Legal.LegalLinksDrawer = LegalLinksDrawer;
export default Legal;
